import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import SafeIcon from '../common/SafeIcon';
import BrandLogo from '../common/BrandLogo';
import { useAuth } from '../../context/AuthContext';

export default function AppLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isReelsFeed = pathname === '/app' || pathname === '/app/';
  const { profile } = useAuth();
  const displayName = profile?.full_name || 'U';

  return (
    <div className="flex h-screen supports-[height:100dvh]:h-dvh md:h-screen bg-[var(--bg-base)] text-[var(--text-main)] overflow-hidden font-sans transition-colors duration-300">
      <Sidebar />

      <main className="flex-1 flex flex-col min-h-0 pb-mobile-nav md:pb-0 overflow-hidden md:overflow-y-auto scroll-smooth">
        <div className="md:hidden shrink-0 z-40 bg-[var(--bg-base)]/90 backdrop-blur-md border-b border-[var(--border-subtle)] px-4 py-3 flex items-center justify-between">
          <BrandLogo size="sm" />

          <div className="flex items-center gap-3">
            <button className="text-[var(--text-secondary)] hover:text-[var(--text-main)]">
              <SafeIcon name="Search" className="w-5 h-5" />
            </button>
            <button 
              onClick={() => navigate('/app/perfil')}
              className="w-7 h-7 rounded-full bg-brand-navy flex items-center justify-center text-white text-[10px] font-bold border border-white/20"
            >
              {displayName.charAt(0)}
            </button>
          </div>
        </div>

        <div className={`flex-1 min-h-0 ${isReelsFeed ? 'overflow-hidden' : 'overflow-y-auto'} md:overflow-visible`}>
          <Outlet />
        </div>
      </main>

      <BottomNav />
    </div>
  );
}
